// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Creditor } from './creditor';
import { CreditorDividend } from './creditor-dividend';
import { Dividend } from './dividend';
import { DocumentRecipient } from './document-recipient';
import { EntryEftdatum } from './entry-eftdatum';
import { ShareholderDividend } from './shareholder-dividend';
import { SubEntry } from './sub-entry';
import { Transfer } from './transfer';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Entry extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  entryId!: number;
  accountId!: number;
  accountName?: string;
  accountNo?: string;
  address?: string;
  address1?: string;
  adminEntryId?: number;
  adminId?: number;
  bankAddress?: string;
  bankCity?: string;
  bankCode?: string;
  bankName?: string;
  bankPcode?: string;
  bankState?: string;
  batchId?: number;
  bfid?: number;
  bsb?: string;
  countryCode?: string;
  createdBy!: string;
  createdDate!: Date;
  currencyRateId?: number;
  entryDate!: Date;
  entryType!: number;
  flags?: number;
  fxentryId?: number;
  irmark?: string;
  isAltPayee?: boolean;
  isToBePrinted!: boolean;
  memo?: string;
  payeeCity?: string;
  payeeCountry?: string;
  payeeEmail?: string;
  payeePcode?: string;
  payeeState?: string;
  printDate?: Date;
  reference1?: string;
  reference2?: string;
  relatedEntryId?: number;
  sweepId?: number;
  targetCcy?: string;
  targetRate?: number;
  targetTotal?: number;
  transferId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  creditorDividends!: CreditorDividend[];
  creditors!: Creditor[];
  dividends!: Dividend[];
  documentRecipients!: DocumentRecipient[];
  entryEftdatum!: EntryEftdatum;
  fxentry!: Entry;
  inverseFxentry!: Entry[];
  inverseRelatedEntry!: Entry[];
  relatedEntry!: Entry;
  shareholderDividends!: ShareholderDividend[];
  subEntries!: SubEntry[];
  transfer!: Transfer;
}

